import { createContext, useContext, ReactNode } from "react"

export type PageVisibility = "public" | "private"

// A public page always belongs to one agency's public roster, so its id
// travels with the visibility (the tag filter is scoped to it, ZAN-922).
type PageVisibilityContextType =
  | { visible: "public"; publicAgencyId: string }
  | { visible: "private"; publicAgencyId?: never }

const PageVisibilityContext = createContext<
  PageVisibilityContextType | undefined
>(undefined)

type PageVisibilityProviderProps = PageVisibilityContextType & {
  children: ReactNode
}

export const PageVisibilityProvider = ({
  children,
  ...value
}: PageVisibilityProviderProps) => {
  return (
    <PageVisibilityContext.Provider value={value}>
      {children}
    </PageVisibilityContext.Provider>
  )
}

export const usePageVisibility = (): PageVisibility => {
  const context = useContext(PageVisibilityContext)
  return context?.visible ?? "private"
}

// The agency whose public roster this page shows, or null on private pages.
export const usePublicAgencyId = (): string | null => {
  const context = useContext(PageVisibilityContext)
  return context?.visible === "public" ? context.publicAgencyId : null
}
